import type {MeshesNode} from "#pricing/nodes/meshes-node"
import {PricingNode, registerPricingGraphNode} from "#pricing/pricing-node"
import type {PricingContext} from "#pricing/pricing-context"
import type {Evaluator, GraphNodeDefinition} from "@cm/graph-v3"
import {graphNode} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export type MeshAmountNodeParameters = {
    name: string
    meshes: MeshesNode
}

const meshAmountNodeDefinition = {
    nodeClass: "MeshAmountNode",
    validation: {
        parameters: z.object({
            name: z.string(),
            meshes: graphNode<MeshesNode>("MeshesNode"),
        }),
        returns: z.number(),
    },
} satisfies GraphNodeDefinition<number, MeshAmountNodeParameters>

/** Resolves to the number of meshes with the given name in the scene (as provided by the connected MeshesNode). 0 if no such mesh exists. */
@registerPricingGraphNode
export class MeshAmountNode extends PricingNode<number, MeshAmountNodeParameters> {
    public override get definition() {
        return meshAmountNodeDefinition
    }

    override run = async (evaluator: Evaluator<PricingContext>) => {
        const meshes = await evaluator.get(this.parameters.meshes)
        return meshes.find((mesh) => mesh.name === this.parameters.name)?.amount ?? 0
    }
}
